import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { EMOJI } from '../constants/constant';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appInputText]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextDirective),
      multi: true
    }
  ]
})
export class InputTextDirective implements ControlValueAccessor {
  private _onChange: (value: any) => {};
  private _onTouched: (value: any) => {};

  constructor(private el: ElementRef) { }
  writeValue(value: any): void {
    this.setInputValue(value || '');
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let value = this.el.nativeElement.value;
    this._onChange(this.setInputValue(value));
  }

  private setInputValue(value: string): string {
    value = value?.replace(EMOJI, '');
    this.el.nativeElement.value = value;
    return value;
  }
}
